var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      staticClass: "ui-button",
      class: {
        "md-accent": _vm.secondary,
        "md-dense": _vm.dense,
        "md-fab": _vm.floating,
        "md-icon-button":
          (_vm.svgIcon || _vm.icon || _vm.$slots["icon"]) && !_vm.text,
        "md-primary": _vm.primary,
        "md-raised": _vm.raised,
        "ui-button--large": _vm.large,
      },
      attrs: { disabled: _vm.disabled, type: _vm.type },
      on: {
        click: function ($event) {
          return _vm.$emit("click", $event)
        },
        mouseleave: function ($event) {
          return _vm.$emit("mouseleave")
        },
      },
    },
    [
      _vm.icon ? _c("md-icon", { class: _vm.icon }) : _vm._e(),
      _vm._v(" "),
      _vm.svgIcon
        ? _c(
            "svg",
            {
              attrs: {
                width: "24",
                height: "24",
                version: "1.1",
                xmlns: "http://www.w3.org/2000/svg",
              },
            },
            [_vm._t("default")],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._t("icon"),
      _vm._v(" "),
      _c("span", [_vm._v(_vm._s(_vm.text))]),
      _vm._v(" "),
      _vm.tooltip ? _c("md-tooltip", [_vm._v(_vm._s(_vm.tooltip))]) : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }